import { TeamsView } from '@/domains/teams/components/TeamsView';
import { UtilisationPeriodSelector } from '@/domains/teams/components/UtilisationPeriodSelector';
import { useCreateTeam, useTeams } from '@/domains/teams/hooks/useTeams';
import { useUtilisationPeriod } from '@/domains/teams/hooks/useUtilisationPeriod';
import { formatPeriodLabel } from '@/domains/teams/lib/utilisationPeriod';
import { useNavigate } from 'react-router';

export function TeamsPage() {
  const navigate = useNavigate();
  // The utilisation column is period-scoped (CWL-157), so the selected range is
  // part of the request rather than a display-only filter.
  const { period, range, query, selectorProps } = useUtilisationPeriod();
  const { data: teams = [], isLoading, isError } = useTeams(query);
  const createTeam = useCreateTeam();

  return (
    <TeamsView
      teams={teams}
      isLoading={isLoading}
      isError={isError}
      utilisationControl={<UtilisationPeriodSelector {...selectorProps} showLabel={false} />}
      utilisationPeriodLabel={formatPeriodLabel(period, range)}
      onTeamClick={(teamId) => navigate(`/teams/${teamId}`)}
      onCreateTeam={async (name, description, maxCapacity, memberIds, teamLeadId) => {
        await createTeam.mutateAsync({
          name,
          ...(description && { description }),
          ...(maxCapacity !== null && { maxCapacity }),
          ...(memberIds.length > 0 && { memberIds }),
          ...(teamLeadId !== null && { teamLeadId }),
        });
      }}
    />
  );
}
